import {
  LocalStorageAccessToken,
  LocalStorageSelectedCompany,
  LocalStorageUserInfo,
} from "./types";

export class BaseService {
  get userInfo(): LocalStorageUserInfo | null {
    const localUserInfo = localStorage.getItem('userInfo');
    return localUserInfo ? JSON.parse(localUserInfo) : null;
  }

  get commercialUserEmail(): string | null {
    const info = this.userInfo;
    if (!info) return null;
    const isCommercialUser = info.userType === 6 || info.userType === 7;
    return isCommercialUser ? info.email : null;
  }

  get selectedCompany(): LocalStorageSelectedCompany | null {
    const localSelectedCompany = localStorage.getItem('selectedCompany');
    return localSelectedCompany ? JSON.parse(localSelectedCompany) : null;
  }

  get accessToken(): LocalStorageAccessToken | null {
    const localAccessToken = localStorage.getItem('accessToken');
    return localAccessToken ? JSON.parse(localAccessToken) : null;
  }

  /**
   * Token da API antiga (Tecpay-api).
   *
   * É o que ela valida: um HS256 próprio, com issuer, audience e os claims UserId
   * e BusinessId dela. O `accessToken` é o token do VAULT — RS256, outro issuer e
   * sem esses claims — e chega lá como 401. Quem passa pelo axios compartilhado já
   * recebe este; quem monta a chamada à mão precisa pedi-lo aqui.
   *
   * A queda para o `accessToken` mantém de pé a sessão aberta antes da virada do
   * login, onde ele ainda é o próprio token legado — é a mesma regra do
   * interceptor em `services/providers/api.ts`.
   */
  get legacyAccessToken(): LocalStorageAccessToken | null {
    const localLegacyToken = localStorage.getItem('legacyAccessToken');
    return localLegacyToken ? JSON.parse(localLegacyToken) : this.accessToken;
  }
}
